import { NavLink } from "react-router-dom";
import { useAuth } from "../auth/AuthProvider";
import { visibleNav } from "../lib/permissions";
import { RoleChip } from "./RoleChip";

export function Sidebar() {
  const { me } = useAuth();
  if (!me) return null;
  const groups = visibleNav(me);

  return (
    <aside
      className="hidden md:flex md:flex-col w-64 shrink-0 border-r"
      style={{ borderColor: "var(--rule)", background: "var(--bg)" }}
    >
      {/* Masthead block */}
      <div className="px-5 pt-7 pb-5 border-b" style={{ borderColor: "var(--rule)" }}>
        <div className="font-display font-semibold text-2xl leading-tight">
          Simpleey Print
        </div>
        <div className="mt-4 flex flex-col gap-1">
          <RoleChip group={me.group_name} />
          <div className="font-mono text-[11px] text-[var(--fg-muted)] mt-1.5">
            <span className="text-[var(--fg-faint)]">@</span>
            {me.username}
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav className="flex-1 overflow-y-auto pb-8">
        {groups.map((g) => (
          <div key={g.section}>
            <div className="np-nav-section">{g.section}</div>
            <ul>
              {g.items.map((it) => (
                <li key={it.to}>
                  <NavLink
                    to={it.to}
                    end={it.to === "/"}
                    className="np-nav-link"
                  >
                    {({ isActive }) => (
                      <>
                        <span className="np-nav-marker" aria-hidden>
                          {isActive ? "▍" : it.marker ?? "·"}
                        </span>
                        <span>{it.label}</span>
                      </>
                    )}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>

    </aside>
  );
}
